import { Fab, SxProps, Theme, useScrollTrigger, Zoom } from "@mui/material";
import { CSSProperties } from "react";
import { ArrowUp } from "src/generated/icons";
import { useScreenSize } from "src/hooks/useScreenSize";

export interface BackToTopButtonProps {
    /**
     * Parent component style as CSSProperties
     */
    sx?: CSSProperties;
    /**
     * Button style as SxProps<Theme>
     */
    iconSx?: SxProps<Theme>;

    /**
     * Show the button for desktop as well
     */
    showForDesktop?: boolean;
}

/**
 * Button to scroll back to top of the page
 * Renders only in mobile view or if attribute "showForDesktop" is set to true
 */

export const BackToTopButton = ({ sx, iconSx, showForDesktop = false }: BackToTopButtonProps) => {
    const { isMobile, isDesktop } = useScreenSize();
    const trigger = useScrollTrigger({ threshold: 300 });
    const style: CSSProperties | undefined = {
        position: "fixed",
        bottom: "3rem",
        left: isDesktop ? "unset" : "1.5rem",
        right: isDesktop ? "3rem" : "unset",
        zIndex: 100,
    };

    return isMobile || (isDesktop && showForDesktop) ? (
        <Zoom in={trigger} role="presentation" style={sx ? { ...style, ...sx } : { ...style }} data-testid={"back-to-top-btn"}>
            <Fab
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                color="primary"
                size="small"
                aria-label="scroll back to top"
                sx={{ ...iconSx }}
            >
                <ArrowUp />
            </Fab>
        </Zoom>
    ) : (
        <></>
    );
};
